import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-ess-details-popup',
  templateUrl: './ess-details-popup.component.html',
  styleUrls: ['./ess-details-popup.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class EssDetailsPopupComponent implements OnInit {
  buttonColorName: any
  PopupName: any
  invitationEmailBody: any = null;
  submissionEmailBody: any = null;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter Email here...',
    defaultParagraphSeparator: '',
  }
  createSurveyForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserRole: any;
  selectedYear: any;
  minDate = new Date();
  intructionList: any = [];
  selectedLocationForSetup: any = [];
  selectedBandForSetup: any = [];
  selectedGradeForSetup: any = [];
  selectedFunctionForSetup: any = [];
  surveyDateOfJoining: any;
  isPublished: boolean = false;
  selectedSurveyID: any;
  selectedEssendDate: any;
  moduleName: any;
  myMasterSelectedYear:any;
  isFieldsDisabled:boolean=false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public sharedService: SharedService, public dialogRef: MatDialogRef<EssDetailsPopupComponent>,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, private datePipe: DatePipe, public dialog: MatDialog,
    public toastr: ToastrService,private pdfDownload:DownloadAsPdfService) { }

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.PopupName = this.data.popupName;
    this.moduleName = this.data.moduleName;
    this.selectedYear = this.data?.year;
    this.myMasterSelectedYear = this.sharedService.transformYearToFyFormat(this.data?.year);
    this.selectedLocationForSetup = this.data?.selectedLocationForSetup
    this.selectedBandForSetup = this.data?.selectedBandForSetup
    this.selectedGradeForSetup = this.data?.selectedGradeForSetup
    this.selectedFunctionForSetup = this.data?.selectedFunctionForSetup
    this.surveyDateOfJoining = this.data?.surveyDateOfJoining
    this.isPublished = this.data?.isPublished;
    this.selectedEmployeeId = this.data?.selectedEmployeeId ? this.data?.selectedEmployeeId : [];

    this.selectedEssendDate = this.data?.endDate
    this.selectedSurveyID = this.data?.selectedSurveyID;
    if (this.moduleName == 'ESS') {
      if (this.data?.invitationEmailBody) {
        this.invitationEmailBody = this.data?.invitationEmailBody;
      } else {
        this.invitationEmailBody = `Dear <b>#EMPLOYEE_NAME#</b>, 
        <br /> <br />
        Thank you for completing the Employee Satisfaction Survey (ESS).
        <br /><br />
        <b>Survey Details:</b> 
        <br /><br />
        <ul>
          <li style="margin-left:15px;"><b>Survey Name:</b> #ESS_SURVEY_NAME#</li>
          <li style="margin-left:15px;"><b>Submitted On:</b> #SUBMISSION_DATE#</li>
        </ul>
        <br /><br />
        Your feedback is valuable and will help us improve our workplace. If you have further suggestions, feel free to contact HR
        <br /><br />
        Best regards, 
        <br />
        <b>#HR_ADMIN_NAME# </b>,
        <br />Human Resources Team`;
      }
      this.invitationEmailSubject = this.data?.invitationEmailSubject ? this.data?.invitationEmailSubject : 'Your Feedback Matters: Participate in the ESS Survey Now!';
      this.submissionEmailBody = this.data?.submissionEmailBody
      if (this.data?.submissionEmailBody) {
        this.submissionEmailBody = this.data?.submissionEmailBody;
      } else {
        this.submissionEmailBody = `
        Dear <b>#EMPLOYEE_NAME#</b>,
        <br /> <br />
        Thank you for completing the Employee Satisfaction Survey (ESS).
        <br /><br />
        <b>Survey Details:</b> 
        <br /><br />
        <ul>
          <li style="margin-left:15px;"><b>Survey Name:</b> #ESS_SURVEY_NAME#</li>
          <li style="margin-left:15px;"><b>Submitted On:</b> #SUBMISSION_DATE#</li>
        </ul>
        <br /><br />
        Your feedback is valuable and will help us improve our workplace. If you have further suggestions, feel free to contact HR
        <br /><br />
        Best regards, 
        <br />
        <b>#HR_ADMIN_NAME# </b>,
        <br />Human Resources Team`;
      }
      this.submissionEmailSubject = this.data?.submissionEmailSubject ? this.data?.submissionEmailSubject : 'Thank You for Completing the ESS Survey!';
    } else {
      if (this.data?.invitationEmailBody) {
        this.invitationEmailBody = this.data?.invitationEmailBody;
      } else {
        this.invitationEmailBody = `Dear <b>#EMPLOYEE_NAME#</b>, 
          <br /> <br />
          The 360-degree feedback review process has been initiated, and you are required to complete one or more  reviews in One or more roles.
          <br /><br />
          <ul>
            <li style="margin-left:15px;"><b>Self-Review:</b>Complete your self-assessment.</li>
            <li style="margin-left:15px;"><b>Superior Review:</b>Provide feedback for your direct report(s). ( Emp. Name)</li>
            <li style="margin-left:15px;"><b>Peer Review:</b> Share your feedback for your colleagues.( Emp. Name)</li>
            <li style="margin-left:15px;"><b>Subordinate Review:</b> Provide feedback for your manager. ( Emp. Name)</li>
            <li style="margin-left:15px;"><b>Internal Customer Review:</b>Give feedback on service/support received. ( Emp. Name)</li>
          </ul>
          <br /><br />
          To ensure timely completion, please submit your reviews before [Due Date].
          <br /><br />
          Access the survey: [Link to Review Portal]
          <br/><br/>
          Best regards, 
          <br />
          <b>#HR_ADMIN_NAME# </b>,
          <br />Human Resources Team`;
      }
      this.invitationEmailSubject = this.data?.invitationEmailSubject ? this.data?.invitationEmailSubject : 'Requests for 360-Degree Feedback ( Survey Name)';
      this.submissionEmailBody = this.data?.submissionEmailBody
      if (this.data?.submissionEmailBody) {
        this.submissionEmailBody = this.data?.submissionEmailBody;
      } else {
        this.submissionEmailBody = `
          Dear <b>#EMPLOYEE_NAME#</b>,
          <br /> <br />
          Thank you for taking the time to complete our survey. Your responses have been successfully submitted.
          <br /><br />
          We appreciate your valuable feedback, which will help us improve our [purpose of the survey]. If you have any further input, feel free to reach out to us.          <br /><br />
          Best regards, 
          <br />
          <b>#HR_ADMIN_NAME# </b>,
          <br />Human Resources Team`;
      }
      this.submissionEmailSubject = this.data?.submissionEmailSubject ? this.data?.submissionEmailSubject : 'Thank You for Completing the Survey!';
    }
    this.intructionList = this.data?.intructionList

    this.initilaizeAddSurveyForm();
    if (this.PopupName == 'Create Survey') {
      this.getessName();
    }
    if (this.PopupName == 'View Employees') {
      this.getEmpListForEssSetup();
    }
    if (this.PopupName == 'My Master') {
      this.getessByID();
    }
    if (this.PopupName == '360 Review') {
      this.getReviewByID();
    }
  }

  initilaizeAddSurveyForm() {
    this.createSurveyForm = this.fb.group({
      essName: [null, Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }
  createSurvey() {

    const test = this.selectedYear?.split('-');
    this.createSurveyForm.markAllAsTouched();
    if (this.createSurveyForm.valid) {
      this.closeDialog();
      const request = {
        "band": [],
        "companyId": this.loggedInUserCompanyID,
        "department": [],
        "dimension": [],
        "employee": [],
        "endDate": this.datePipe.transform(this.createSurveyForm.value.endDate, "yyyy-MM-dd"),
        "essName": this.createSurveyForm.value.essName,
        "essStatus": "Pending",
        "fromYear": test[0],
        "grade": [],
        "id": null,
        "instruction": [],
        "invitationEmailBody": null,
        "invitationEmailSubject": null,
        "isReminderOn": false,
        "isReportsVisibleToHr": false,
        "location": [],
        "ratings": [],
        "reminderDate": [],
        "startDate": this.datePipe.transform(this.createSurveyForm.value.startDate, "yyyy-MM-dd"),
        "submissionEmailBody": null,
        "submissionEmailSubject": null,
        "surveyCutoff": null,
        "templateName": null,
        "toYear": test[1]
      }
      this.httpService.callPostService(this.config.essSave, request).
        subscribe((data: any) => {
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          }
        })
    }
  }
  instructionName: any = '';
  onClickAddInstruction() {
    if (this.instructionName != '') {
      this.intructionList.push(this.instructionName)
      this.instructionName = '';
    }
  }
  onClickRemoveInstruction(index: any) {
    this.intructionList.splice(index, 1);
  }
  onClickCloseInstruction() {
    this.dialogRef.close(this.intructionList);
  }
  onClickSaveInstruction() {
    if (this.intructionList.length != 0) {
      this.dialogRef.close(this.intructionList);
    } else {
      this.toastr.error('Please fill fields', '', {
        timeOut: 3000,
      });
    }
  }
  invitationEmailSubject: any = 'Your Feedback Matters: Participate in the ESS Survey Now!';
  submissionEmailSubject: any = 'Thank You for Completing the ESS Survey!';
  onClickSaveInvitation() {
    if (this.invitationEmailBody != '' && this.invitationEmailSubject != '') {
      let data = {
        invitationEmailBody: this.invitationEmailBody,
        invitationEmailSubject: this.invitationEmailSubject
      }
      this.dialogRef.close(data);
    } else {
      this.toastr.error('Please fill fields', '', {
        timeOut: 3000,
      });
    }
  }
  onClickCloseInvitation() {
    let data = {
      invitationEmailBody: this.invitationEmailBody,
      invitationEmailSubject: this.invitationEmailSubject
    }
    this.dialogRef.close(data);
  }
  onClickSaveSubmission() {
    if (this.submissionEmailSubject != '' && this.submissionEmailBody != '') {
      let data = {
        submissionEmailSubject: this.submissionEmailSubject,
        submissionEmailBody: this.submissionEmailBody
      }
      this.dialogRef.close(data);
    } else {
      this.toastr.error('Please fill fields', '', {
        timeOut: 3000,
      });
    }
  }
  onClickCloseSubmission() {
    let data = {
      submissionEmailSubject: this.submissionEmailSubject,
      submissionEmailBody: this.submissionEmailBody
    }
    this.dialogRef.close(data);
  }
  listOfEmployees: any = [];
  searchString: any = null;
  getEmpListForEssSetup() {

    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "depts": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
      "doj": this.datePipe.transform(this.surveyDateOfJoining, "yyyy-MM-dd"),
      "endDate": this.selectedEssendDate,
      "search": this.searchString
    }
    // this.loader.simpleLoader();
    this.httpService.callPostService(this.config.getEmpListForEssSetup, request).subscribe((data: any) => {
      // this.loader.dismissLoader();
      this.listOfEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          isChecked: false,
          employeeId: ele.employeeId,
          firstName: ele.firstName,
          lastName: ele.lastName,
          dateOfJoining: ele.dateOfJoining,
          designation: ele.designation,
          department: ele.department,
          reportingManagerName: ele.reportingManagerName,
          officeLocation: ele.workLocationCity,
          band: ele.band,
          grade: ele.grade,
        }
        this.listOfEmployees.push(obj);
      });
      this.listOfEmployees.forEach((item: { id: any; isChecked: boolean; }) => {
        if (this.selectedEmployeeId.some((emp: { id: any }) => emp.id === item.id)) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      });
      
      if (this.selectedEmployeeId.length == 0) {
        this.isAllEmployeeSelected = true;
        this.listOfEmployees.forEach((item: { isChecked: boolean; }) => {
          item.isChecked = true;
        });
        this.selectedEmployeeId = this.listOfEmployees;
      }
      if (this.listOfEmployees.length == this.selectedEmployeeId.length) {
        this.isAllEmployeeSelected = true;
      }
    })
  }
  debounceTimer: any;
  selectedEmployeeId: any = [];
  isAllEmployeeSelected: boolean = false;
  onSearchInput(event: any) {
    this.searchString = event.target.value;
    if (this.searchString == '') {
      this.searchString = null;
    } if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.getEmpListForEssSetup();
    }, 300);
  }
  onClickSaveViewEmp() {

    let data = {}
    if (this.moduleName == 'ESS') {
      this.selectedEmployeeId = this.selectedEmployeeId.map((item: any) => {
        if (typeof item === 'object' && item.id) {
          // Find in firstArray and merge if necessary
          const foundItem = this.listOfEmployees.find((emp: any) => emp.id === item.id);
          return foundItem ? { ...foundItem, ...item } : item;
        }
        return this.listOfEmployees.find((emp: any) => emp.id === item) || null; // Get full object if only id is provided
      }).filter(Boolean); // Remove null values if no match is foun

      data = {
        selectedEmployeeId: this.selectedEmployeeId,
      }
    } else {
      this.selectedEmployeeId = this.selectedEmployeeId.map((item: any) => {
        if (typeof item === 'object' && item.id) {
          // Find in firstArray and merge if necessary
          const foundItem = this.listOfEmployees.find((emp: any) => emp.id === item.id);
          return foundItem ? { ...foundItem, ...item } : item;
        }
        return this.listOfEmployees.find((emp: any) => emp.id === item) || null; // Get full object if only id is provided
      }).filter(Boolean); // Remove null values if no match is foun

      data = {
        selectedEmployeeId: this.selectedEmployeeId,
      }
    }
    this.dialogRef.close(data);
  }
  onSelectAllEmployee(event: any) {
    this.selectedEmployeeId = [];
    if (event.checked) {
      this.isAllEmployeeSelected = true;
      this.listOfEmployees.forEach((ele: any) => {
        ele.isChecked = true
        this.selectedEmployeeId.push(ele);
      });
    } else {
      this.listOfEmployees.forEach((ele: any) => {
        ele.isChecked = false
      });
      this.isAllEmployeeSelected = false;
      this.selectedEmployeeId = [];
    }
  }
  onSelectSingleEmployee(event: any, item: any, index: any) {
    if (event.checked) {
      this.listOfEmployees[index].isChecked = true;
      this.selectedEmployeeId.push(item);
    } else {
      this.isAllEmployeeSelected = false;
      this.listOfEmployees[index].isChecked = false;
      this.listOfEmployees.forEach((ele: any, ind: any) => {
        if (ele.isChecked == false) {
          this.selectedEmployeeId.splice(ind, 1);
        }
      });
    }
  }
  selectedSurveyName: any = null;
  selectedSurveyStartDate: any;
  selectedSurveyEndDate: any;
  selectedSurveyStatus: any;
  isShowDashboardToHR: any;
  onSeletReminderOption: boolean = false;
  isShowReminderDate: any = false;
  selectedTemplateColorName: any;
  templateColorList = [
    {
      stripcolor: "#db4437",
      backgroundColor: "#fae3e1",
      colorName: "Red"
    },
    {
      stripcolor: "#673ab7",
      backgroundColor: "#f0ebf8",
      colorName: "Purple"
    },
    {
      stripcolor: "#3f51b5",
      backgroundColor: "#eceef8",
      colorName: "Indigo"
    }, {
      stripcolor: "#4285f4",
      backgroundColor: "#e3edfd",
      colorName: "Blue"
    },
    {
      stripcolor: "#03a9f4",
      backgroundColor: "#d9f2fd",
      colorName: "Light Blue"
    },
    {
      stripcolor: "#00bcd4",
      backgroundColor: "#d9f5f9",
      colorName: "Cyan"
    },
    {
      stripcolor: "#ff5722",
      backgroundColor: "#ffe6de",
      colorName: "Red Orange"
    },

    {
      stripcolor: "#ff9800",
      backgroundColor: "#fff0d9",
      colorName: "Orange"
    },
    {
      stripcolor: "#009688",
      backgroundColor: "#d9efed",
      colorName: "Teal"
    },
    {
      stripcolor: "#4caf50",
      backgroundColor: "#e4f3e5",
      colorName: "Green"
    },
    {
      stripcolor: "#607d8b",
      backgroundColor: "#e7ecee",
      colorName: "Blue Gray"
    },
    {
      stripcolor: "#9e9e9e",
      backgroundColor: "#f0f0f0",
      colorName: "Gray"
    },
  ]
  selectedTemplateColorCode: any = '#F6921E';
  selectedtemplateBgColor: any;
  isOpenEnded: boolean = false;
  isRatingBased: boolean = true;
  ratingList = [
    {
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: null
    },
  ];



  dimensionsTemplateList = [
    {
      dimensionName: null,
      questions: [
        {
          id: null,
          question: null,
          questionNumber: null,
          questionType: null
        },
      ],
    },
  ];
  mySurveyQuestionList: any = [];
  ratingListOnRatingBased: any = [];
  infoListData: any[] = [];
  getessByID() {
    this.httpService.callGetService(this.config.getessByID + this.selectedSurveyID).subscribe((data: any) => {

      this.selectedSurveyName = data?.data?.essName;
      this.selectedSurveyStartDate = data?.data?.startDate;
      this.selectedSurveyEndDate = data?.data?.endDate;
      this.selectedSurveyStatus = data?.data?.essStatus;
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      this.selectedEmployeeId = data?.data?.employee
      this.selectedLocationForSetup = [];
      data?.data?.location.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedLocationForSetup.push(obj)
      })
      this.selectedBandForSetup = [];
      data?.data?.band.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedBandForSetup.push(obj)
      })
      this.selectedGradeForSetup = [];
      data?.data?.grade.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedGradeForSetup.push(obj)
      })
      this.selectedFunctionForSetup = [];
      data?.data?.department.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedFunctionForSetup.push(obj)
      })
      this.surveyDateOfJoining = data?.data?.surveyCutoff;
      this.onSeletReminderOption = data?.data?.isReminderOn;
      this.selectedTemplateColorName = data?.data?.templateName;

      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      })

      if (data?.data?.instruction?.length != 0) {
        this.intructionList = data?.data?.instruction;
      }
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: null
          },
        ]
      }
      this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
      this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
      if (data?.data?.questions?.length != 0) {
        this.dimensionsTemplateList = data?.data?.questions;
      } else {
        this.dimensionsTemplateList = [
          {
            dimensionName: null,
            questions: [
              {
                id: null,
                question: null,
                questionNumber: null,
                questionType: null
              },
            ],
          },
        ];
      }
      this.invitationEmailBody = data?.data?.invitationEmailBody;
      this.invitationEmailSubject = data?.data?.invitationEmailSubject;
      this.submissionEmailBody = data?.data?.submissionEmailBody;
      this.submissionEmailSubject = data?.data?.submissionEmailSubject;

      this.mySurveyQuestionList = data?.data?.questions.flatMap((dimension: { questions: any; }) => dimension.questions);
      this.mySurveyQuestionList = this.mySurveyQuestionList.map((question: any) => ({
        ...question,
        answer: null // You can set a default value or any specific value
      }));
      this.ratingListOnRatingBased = [];
      data?.data?.ratings.forEach((ele: any) => {
        if (ele.questionType == 'Rating Based') {
          this.ratingListOnRatingBased.push(ele)
        }
      })
    })
  }
  exportEssEmployee() {

    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "endDate": this.selectedEssendDate,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "depts": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
      "doj": this.datePipe.transform(this.surveyDateOfJoining, "yyyy-MM-dd"),
      "search": this.searchString,
       "id": this.selectedEmployeeId?.map((ele: { id: any; }) => ele.id),
    }
    // this.loader.simpleLoader();
    this.httpService.callPostService(this.config.downloadEssEmps, request).subscribe((data: any) => {
      saveAs(data?.fileUrl, "Employees.xlsx");
    })
  }
  essNamesList: any = [];
  allEssDateList: any = [];
  getessName() {
    if (this.selectedYear != null) {
      const test = this.selectedYear?.split('-');
      this.httpService.callGetService(this.config.getessName + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {

        this.essNamesList = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.essName,
          }
          this.essNamesList.push(obj);
        });
        this.allEssDateList = data?.data?.flatMap((item: any) => this.getDatesBetween(item.startDate, item.endDate));

        this.allEssDateList = Array.from(new Set(this.allEssDateList));
      })
    }
  }
  getDatesBetween(startDateStr: string, endDateStr: string): string[] {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const dates: string[] = [];

    while (startDate <= endDate) {
      dates.push(startDate.toISOString().split("T")[0]); // Format as YYYY-MM-DD
      startDate.setDate(startDate.getDate() + 1); // Increment date by 1
    }

    return dates;
  }
  dateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    // Ensure d is a Date object
    const date = new Date(d);

    // Normalize date to ignore time part
    const selectedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const minDateOnly = new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate());

    // Convert to YYYY-MM-DD string for accurate comparison
    const dateString = selectedDate.toISOString().split('T')[0];

    console.log('Checking date:', dateString, 'Min Date:', minDateOnly.toISOString().split('T')[0]);

    // Ensure the selected date is not before minDate and not in the disabled list
    return selectedDate >= minDateOnly && !this.allEssDateList.includes(dateString);
  };
  selectedReviewName:any;
  selectedReviewStartDate:any;
  selectedReviewStatus:any;
  selectedReviewEndDate:any;
  isExternalCustomerEnabled:any;
  stakeHoldersArrayForSetup:any=[];
  reviewDateOfJoining:any;
  ratingBasedList:any=[];
  externalCustomerWeightage:any;
  subordinateWeightage:any;
  superiorWeightage:any;
  selfWeightage:any;
  peerWeightage:any;
  stakeholdersArray:any=[];
  internalCustomerWeightage:any;
  getCompetencyList:any=[];
  participatein360ReviewArrayList:any=[];
  getReviewByID() {
    this.httpService.callGetService(this.config.getReview360ById + this.selectedSurveyID).subscribe((data: any) => {
      this.selectedReviewName = data?.data?.reviewName;
      this.selectedReviewStartDate = data?.data?.startDate;
      this.selectedReviewEndDate = data?.data?.endDate;
      this.selectedReviewStatus = data?.data?.reviewStatus;
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr;
      this.isExternalCustomerEnabled = data?.data?.isExternalCustomerEnabled;
      this.onSeletReminderOption = data?.data?.isReminderOn;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      if (this.isExternalCustomerEnabled == true) {
        this.stakeHoldersArrayForSetup.push({ name: 'External Customer' });
      }

      this.selectedLocationForSetup = [];
      data?.data?.location.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedLocationForSetup.push(obj)
      })
      this.selectedBandForSetup = [];
      data?.data?.band.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedBandForSetup.push(obj)
      })
      this.selectedGradeForSetup = [];
      data?.data?.grade.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedGradeForSetup.push(obj)
      })
      this.selectedFunctionForSetup = [];
      data?.data?.department.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedFunctionForSetup.push(obj)
      })
      this.selectedEmployeeId = [];
      data?.data?.employee?.forEach((ele: any) => {
        let obj = {
          id: ele
        }
        this.selectedEmployeeId.push(obj);
      })
      this.selectedTemplateColorName = data?.data?.templateName ? data?.data?.templateName : 'Red';
      this.reviewDateOfJoining = data?.data?.reviewCutoff;
      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      })

      if (data?.data?.instruction?.length != 0) {
        this.intructionList = data?.data?.instruction;
      }
      this.ratingBasedList = [];
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
        data?.data?.ratings?.forEach((ele: any) => {
          if (ele.questionType == 'Rating Based') {
            let obj = {
              id: ele.id,
              questionType: ele.questionType,
              rating: ele.rating,
              ratingDefinition: ele.ratingDefinition
            }
            this.ratingBasedList.push(obj)
          }
        })
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: null
          },
        ]
      }
      this.invitationEmailBody = data?.data?.invitationEmailBody;
      this.invitationEmailSubject = data?.data?.invitationEmailSubject;
      this.submissionEmailBody = data?.data?.submissionEmailBody;
      this.submissionEmailSubject = data?.data?.submissionEmailSubject;
      this.externalCustomerWeightage = data?.data?.externalCustomerWeightage
      this.subordinateWeightage = data?.data?.subordinateWeightage
      this.superiorWeightage = data?.data?.superiorWeightage
      this.selfWeightage = data?.data?.selfWeightage
      this.peerWeightage = data?.data?.peerWeightage
      this.internalCustomerWeightage = data?.data?.internalCustomerWeightage
      
      this.stakeholdersArray = data?.data?.stakeholders;
      this.getCompetencyList = data?.data?.competencies;

      this.participatein360ReviewArrayList = data?.data?.competencies?.flatMap((item: any) => item.competencies)
        .reduce((acc: any, curr: any) => {
          const existing = acc.find((comp: any) => comp.competencyName === curr.competencyName);
          if (existing) {
            existing.questions.push(...curr.questions);
          } else {
            acc.push({ competencyName: curr.competencyName, questions: [...curr.questions] });
          }
          return acc;
        }, [] as { competencyName: string; questions: { id: number; question: string; questionType: string, answers: any }[] }[]);
    })
  }
  onClickDownloadGraphAsPdf(id:any){
    let title = '';
    if(id == 'activeessReview'){
      title = 'Employee Satisfaction Survey'
    }else if(id == 'active360Review'){
      title = '360 Review'
    }
    this.pdfDownload.PDFDownload(
      id, // chartId
      title, // lable
    );
  }
}
